import React from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import { useState, useEffect } from 'react';
import config from "../config";
 
const OrderList = ({ orders, setOrders }) => {
    const apiBaseUrl = config.REACT_APP_API_BASE_URL;
    const [currentOrder, setCurrentOrder] = useState([]);

    useEffect(() => {
        setCurrentOrder(orders);
        console.log(currentOrder);
    }, [orders]);

    const updateOrder = async (orderId, showAlert = true) => {
        if (showAlert) {
            const result = await Swal.fire({
                title: 'Confirm Order',
                text: 'Deliver Order?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes!',
            });
            if (!result.isConfirmed) return;
        }


        try {
            const response = await axios.put(`${apiBaseUrl}/api/orders/edit-order`, {
                orders: [{ orderId, order_progressstatus: "Receive" }]
            });

            if (response.data && response.data[0].status === 'success') {
                setOrders((prev) => prev.filter(order => order.oid !== orderId));
            } else {
                console.error("Order update failed:", response.data[0].message);
            }
        } catch (error) {
            console.error("API error:", error);
        }
    }

    const UpdateOrderItem = async (item, orderId, orderOid) => {
        const result = await Swal.fire({
            title: item.product.name,
            text: `Deliver ${item.product.name}?`,
            imageUrl: item.product.image,
            imageWidth: 400,
            imageHeight: 300,
            showCancelButton: true,
            confirmButtonText: 'Yes!',
        });
        if (!result.isConfirmed) return;

        try {
            const response = await axios.put(`${apiBaseUrl}/api/orders/update-order-item`, {
                _id: orderId,
                orderItems_id: item._id,
            });

            const isOrderComplete = response.data.updatedOrder.order_items.every(
                (item) => item.product.itemDeliverStatus === true
            );

            if (response.data.status === 'success') {
                if (isOrderComplete) {
                    setOrders((prev) => prev.filter(order => order._id !== orderId));
                    updateOrder(orderOid, false);
                } else {
                    setOrders((prev) =>
                        prev.map((order) => {
                            if (order._id === orderId) {
                                return {
                                    ...order,
                                    order_items: order.order_items.filter(
                                        (orderItem) => orderItem._id !== item._id
                                    )
                                };
                            }
                            return order;
                        })
                    );
                }
            } else {
                console.error("Order update failed:", response.data?.message);
            }
        } catch (error) {
            console.error("API error:", error);
        }
    }


    return (
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '1rem' }}>
            {Array.isArray(currentOrder) && currentOrder.length > 0 ? (
                currentOrder.map((order, index) => (
                    <div
                        key={index}
                        style={{
                            width: '300px',
                            minHeight: '170px',
                            border: '1px solid #ccc',
                            borderRadius: '8px',
                            fontSize: '16px',
                            backgroundColor: '#fff',
                            boxShadow: '0 2px 5px rgba(0,0,0,0.1)',
                            display: 'flex',
                            flexDirection: 'column', // 👈 necessary
                            position: 'relative',
                            overflow: 'hidden'
                        }}
                    >
                        <div style={{ flexGrow: 1, padding: '16px', marginBottom: '10%' }}>
                            <div
                                style={{
                                    position: 'absolute',
                                    top: '10px',
                                    right: '15px',
                                    backgroundColor: '#f0f0f0',
                                    padding: '4px 8px',
                                    borderRadius: '4px',
                                    fontSize: '14px',
                                    fontWeight: 'bold'
                                }}
                            >
                                #{order.oid_num || index + 1}
                            </div>

                            <h3>Table {order.order_tablenumber}</h3>
                            {order.order_items
                                ?.filter(item => item.product?.itemDeliverStatus === false)
                                .map((item, i) => (
                                    <div
                                        key={i}
                                        onClick={() => UpdateOrderItem(item, order._id, order.oid)}
                                        onMouseEnter={e => {
                                            e.currentTarget.style.backgroundColor = "#f2f2f2";
                                            e.currentTarget.style.border = "2px solid #4CAF50";
                                        }}
                                        onMouseLeave={e => {
                                            e.currentTarget.style.backgroundColor = "#fff";
                                            e.currentTarget.style.border = "2px solid transparent";
                                        }}
                                        style={{
                                            padding: "10px",
                                            cursor: "pointer",
                                            border: "2px solid transparent",
                                            borderRadius: "6px",
                                            transition: "background 0.2s ease-in-out",
                                            backgroundColor: "#fff",
                                            marginBottom: "8px"
                                        }}
                                    >
                                        <div>
                                            <strong>{item.product.name}</strong> × {item.quantity}
                                            {item.product.addOns?.length > 0 && (
                                                <span style={{ marginLeft: "8px", color: "#888", fontSize: "14px" }}>
                                                    {item.product.addOns.map((addon, idx) => (
                                                        <span key={idx}>
                                                            ({addon.name} {addon.group})
                                                            {idx < item.product.addOns.length - 1 && ', '}
                                                        </span>
                                                    ))}
                                                </span>
                                            )}
                                        </div>

                                        {item.remarks && item.remarks.trim() !== "" && (
                                            <div style={{ marginTop: "4px", fontStyle: "italic", color: "#555", fontSize: "14px" }}>
                                                📝 {item.remarks}
                                            </div>
                                        )}
                                    </div>
                                ))}

                        </div>

                        <button
                            onClick={() => updateOrder(order.oid, true)}
                            style={{
                                background: "green",
                                color: "white",
                                width: "100%",
                                padding: "12px",
                                border: "none",
                                borderTop: "1px solid #ccc",
                                borderBottomLeftRadius: '8px',
                                borderBottomRightRadius: '8px',
                                fontSize: "16px",
                                cursor: "pointer"
                            }}
                        >
                            Complete
                        </button>
                    </div>
                ))
            ) : (
                <div style={{ fontSize: '18px', color: '#777', padding: '20px' }}>
                    No orders to display.
                </div>
            )}
        </div>


    );
};

export default OrderList;
